export default {
  "content": "<path d=\"M8.7 14C6.126 14 1 15.429 1 20h15.4c0-4.571-5.126-6-7.7-6zm0-2c2.123 0 3.85-1.794 3.85-4S10.823 4 8.7 4 4.85 5.794 4.85 8s1.727 4 3.85 4zm6.6 2.069c1.276.96 3.3 2.217 3.3 5.931H23c0-4-4.994-5.623-7.7-5.931zm0-2.069c2.123 0 3.85-1.794 3.85-4s-1.727-4-3.85-4a3.68 3.68 0 00-1.65.4 6.385 6.385 0 011.1 3.6 6.385 6.385 0 01-1.1 3.6 3.68 3.68 0 001.65.4z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#fff",
    "viewBox": "0 0 24 24"
  }
};